module.exports = __webpack_public_path__ + "static/img/correct.bdaa813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mission/correct.png
// module id = rl5g
// module chunks = 0